import { axios } from './core';
import { handleResponse, handleError } from './response';

const singular = 'shop';
const plural = 'shops';

const getShop = () =>
  axios.post(`/${singular}/get`).then(handleResponse).catch(handleError);

const updateShop = (shop) =>
  axios
    .post(`/${singular}/update`, { shop })
    .then(handleResponse)
    .catch(handleError);

const getSystemEmails = () =>
  axios.post(`/${singular}/email/get`).then(handleResponse).catch(handleError);

const updateSystemEmail = (emailData) =>
  axios
    .post(`/${singular}/email/update`, emailData)
    .then(handleResponse)
    .catch(handleError);

const getActiveDiscount = (data) =>
  axios
    .post(`/${singular}/discounts/get`, data)
    .then(handleResponse)
    .catch(handleError);

const getRedeemedDiscount = (data) =>
  axios
    .post(`/${singular}/discounts/get`, data)
    .then(handleResponse)
    .catch(handleError);

const shopAPI = {
  updateShop,
  getShop,
  getSystemEmails,
  updateSystemEmail,
  getActiveDiscount,
  getRedeemedDiscount,
};

export default shopAPI;
